import React from 'react';

function PlaceholderMenuIcon(props) {
  return (
    <svg
      width="420"
      height="420"
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M80.8956 204.272L80.8968 204.273C89.8669 194.442 107.533 185.176 130.784 177.796C107.532 185.176 89.8664 194.441 80.8956 204.272Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M210 44C245.271 44 277.957 55.0667 304.775 73.9172L260.85 131.632L260.356 132.249C243.38 131.349 224.761 131.656 205.313 133.357C129.387 140 69.5876 165.385 71.7461 190.056C71.7627 190.246 71.783 190.436 71.807 190.625C73.6783 211.655 82.9093 293.726 158.28 317.526L159.377 330.062C159.976 336.91 165.163 342.462 171.976 343.287C185.373 344.909 207.673 347.019 223.925 345.542C239.724 344.107 260.668 338.296 273.311 334.433C279.867 332.43 283.997 326.068 283.398 319.227L282.348 307.22C354.45 270.704 348.473 186.193 346.706 166.001C347.163 171.216 344.851 176.462 340.203 181.557C322.864 200.566 273.017 217.461 213.14 222.7C200.385 223.816 187.986 224.331 176.174 224.301C187.984 224.331 200.38 223.815 213.132 222.7C273.008 217.461 322.856 200.566 340.195 181.557L340.194 181.556C344.84 176.462 347.152 171.216 346.696 166.001C345.45 151.761 323.836 140.872 291.183 135.486L328.924 94.6232C357.457 124.284 375 164.593 375 209C375 300.127 301.127 374 210 374C118.873 374 45 300.127 45 209C45 117.873 118.873 44 210 44Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M72.7341 77.528C75.2828 79.3659 78.4222 76.2266 76.5843 73.6778L62.1847 53.7088C59.74 50.3186 54.8505 49.9112 51.909 52.8527C48.9675 55.7942 49.3748 60.6837 52.7651 63.1284L72.7341 77.528Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M73.5249 88.9995C75.765 88.6347 75.765 85.4127 73.5249 85.0479L55.9741 82.1899C52.9943 81.7047 50.2894 84.0047 50.2894 87.0237C50.2894 90.0427 52.9943 92.3427 55.9741 91.8575L73.5249 88.9995Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M89.022 75.8948C88.7302 77.6872 86.152 77.6872 85.8602 75.8948L83.5733 61.8514C83.185 59.4671 85.0255 57.3027 87.4411 57.3027C89.8567 57.3027 91.6972 59.4671 91.3089 61.8513L89.022 75.8948Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M221.934 323.21C196.691 325.418 175.715 323.031 158.279 317.525L159.376 330.061C159.975 336.91 165.162 342.461 171.974 343.286C185.372 344.909 207.672 347.019 223.924 345.542C239.723 344.107 260.667 338.296 273.31 334.433C279.866 332.429 283.996 326.068 283.397 319.226L282.347 307.219C266.351 315.32 246.513 321.059 221.934 323.21Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M340.201 181.557C322.861 200.566 273.014 217.461 213.137 222.7C153.299 227.935 101.303 219.966 80.8989 204.277C75.4134 200.059 72.2112 195.283 71.7539 190.056C73.5099 210.127 82.2058 293.506 158.276 317.526C175.712 323.031 196.688 325.419 221.931 323.21C246.51 321.06 266.348 315.321 282.344 307.22C354.446 270.704 348.47 186.193 346.704 166.001C347.16 171.216 344.848 176.462 340.201 181.557Z"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        d="M207.905 163.139C148.052 168.383 98.2286 185.274 80.8945 204.277C101.299 219.966 153.295 227.935 213.133 222.7C273.01 217.461 322.857 200.566 340.196 181.557C327.793 172.02 303.716 165.336 273.3 162.736C272.521 167.488 272.419 172.485 272.39 177.253C272.368 180.962 271.743 184.687 270.5 188.268L197.004 194.698C198.464 183.76 202.829 171.866 207.905 163.139Z"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        d="M260.356 132.249C243.38 131.349 224.761 131.656 205.313 133.357C129.387 140 69.5876 165.385 71.7461 190.056C72.2034 195.283 75.4056 200.059 80.891 204.277C98.2252 185.274 148.049 168.383 207.902 163.14C209.5 160.392 211.169 157.959 212.84 155.968C218.219 149.557 225.418 145.591 233.004 144.207C243 142.383 253.962 140.048 260.356 132.249Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M273.298 162.737C303.713 165.336 327.79 172.021 340.193 181.558C344.84 176.463 347.152 171.216 346.696 166.001C345.45 151.761 323.834 140.87 291.177 135.485L279.938 147.654C276.1 151.809 274.222 157.1 273.298 162.737Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M354.088 39.9053C361.871 46.4362 362.615 58.1474 355.722 65.6112L279.945 147.653C272.873 155.311 272.457 166.829 272.396 177.253C272.374 180.962 271.748 184.687 270.506 188.268L197.01 194.698C198.929 180.316 205.871 164.282 212.848 155.967C218.227 149.556 225.426 145.59 233.012 144.206C243.267 142.335 254.538 139.927 260.851 131.631L328.489 42.76C334.642 34.6749 346.304 33.3743 354.088 39.9053Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  );
}

export default PlaceholderMenuIcon;
